import Vue from 'vue'
import { ICity, City, DataEntity } from "@/entity/territory/territory.types";
import Component from "vue-class-component";
import {TerritoryStore} from "@/store/modules/Territory";

@Component
export class CityMix extends  Vue {
    get cityLoaded(): boolean {
        return TerritoryStore.citiesLoaded;
    }
    get cities(): City | null {
        return TerritoryStore.cities;
    }
    get city(): DataEntity | null {
        return  TerritoryStore.city
    }


}
